<template>
    <div v-if="poly_vertices">
        <div v-for="(point,ind) in poly_vertices" :key="ind+'point'"> 
        <l-circle
          ref="circle_poly_vertices"
          :options="{ zIndex: 2 }"
          :lat-lng="[JSON.parse(point.geom).coordinates[1],JSON.parse(point.geom).coordinates[0]]"
          :radius="2"
          :color="'orange'"
        >
        <!--<l-tooltip>{{ JSON.parse(point.geom).coordinates[0] }} , {{ JSON.parse(point.geom).coordinates[1] }}</l-tooltip>-->
        
          <l-tooltip>{{ point.x }} , {{ point.y }}</l-tooltip>
        
      </l-circle>
      </div>
    </div>
</template>


<script>
//import L from "leaflet";
import axios_django from "../axios-auth";

export default {
  props: {
    live_zoom: Number,
    id_polygon:Array
  },
  components: {
  
  },
  data() {
    return {

      poly_vertices:null,
    }
  },
 
  mounted(){
    
    this.$nextTick(() => {
  
      //this.$refs.map1.mapObject.sync(this.$refs.map2.mapObject)
      //this.$refs.map2.mapObject.sync(this.$refs.map1.mapObject)
    });
  },
  async created(){
   
    
    
  },
  watch: { 
    id_polygon: function() { // watch it
          var token=localStorage.getItem('token')
          console.log('watchloadPolyVertices',this.id_polygon)
          if(this.id_polygon ){
          this.poly_vertice=null
            axios_django.get('sydapzak/poly_vetrices/',{params:{ids:this.id_polygon[0].ids}, headers: {Authorization: `Bearer ${token}`}}).then(res=>{
            this.poly_vertices=res.data
            console.log(this.poly_vertices)
            //this.$store.commit('set', ['poly_vertices', this.poly_vertices])
            //console.log('this.poly_vertices',this.$store.state.poly_vertices)
          })
          }
        }
  },
  methods:{

   
    
  
  }
 

};
</script>
